import z from "zod"

export const AuthResponseSchema = z.object({
  /** Код, полученный после прохождения авторизации */
  code: z.string().min(1),

  /** Вид токена */
  type: z.string(),

  /** Состояние, указанное в конфиге (должно совпадать с тем, что ты отправлял) */
  state: z.string().min(1),

  /** Идентификатор устройства, использовавшийся для создания кода */
  device_id: z.string(), // device_id в VK ID — это UUID v4

  /** Срок жизни кода авторизации в секундах (обычно 300–600 сек) */
  expires_in: z.number().int().positive().max(3600), // на практике не больше часа

  /**
   * Внутренний параметр, используется VK для своих нужд.
   * Присутствует не всегда, поэтому optional.
   * @ignore
   */
  ext_id: z.string().optional(),
});
// Основная схема AuthError
export const AuthErrorSchema = z.object({
  /** Текст ошибки */
  error: z.string(),

  /** Расширенная информация об ошибке */
  error_description: z.string().optional(),

  /** Страница HTML с человеко-понятным описанием ошибки */
  error_uri: z.string().url().optional(),

  /** Строка переданная в изначальном запросе */
  state: z.string(),

  /** Код ошибки, возникшей во время работы SDK */
  code: z.string().optional(),
});

// Тип для TypeScript (очень удобный бонус)
export type AuthError = z.infer<typeof AuthErrorSchema>;
// Тип для TypeScript — полностью совпадает с твоим интерфейсом
export type AuthResponse = z.infer<typeof AuthResponseSchema>;

export const isAuthResponse = (value: unknown): value is AuthResponse => {
  try {
    AuthResponseSchema.parse(value);
    return true;
  } catch {
    return false;
  }
};

export const isAuthError = (value: unknown): value is AuthError => {
  try {
    AuthErrorSchema.parse(value);
    return true;
  } catch {
    return false;
  }
};